import { keepPercentTwoLine, keepTwoNull } from '@/pages/IndustrialGreenMicBigScreen/utils';
import { V2MicrogridOverviewGetBsaEnergyPostResponse } from '@maxtropy/intelligent-dispath-apis-v2';
import dayjs from 'dayjs';

export const getChartOption = (data?: V2MicrogridOverviewGetBsaEnergyPostResponse) => {
  const chargeData = (data?.chargeInfo ?? []).map(item => keepTwoNull(item.value));
  const disChargeData = (data?.disChargeInfo ?? []).map(item => keepTwoNull(item.value));

  const xData = (data?.chargeInfo ?? []).map(item => item.time);
  return {
    grid: {
      left: 10,
      bottom: 0,
      right: 0,
      top: 40,
      containLabel: true,
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: 'rgba(255,255,255,0.1)',
        },
      },
      textStyle: {
        color: 'rgba(255,255,255,0.85)',
      },
      backgroundColor: 'rgba(0,0,0,0.8)',
      borderColor: 'transparent',
      padding: [8, 12],
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let firstStr = dayjs(axisValue, 'x').format('YYYY-MM-DD');
        let otherStr = '';
        let str = '';
        items.forEach((item: any) => {
          const { seriesName, data, marker } = item;
          otherStr += `<div style="margin-top:8px"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;">${marker}</span>${seriesName} : &nbsp;${
            data || data === 0 ? data : '-'
          }kWh</div>`;
          str = firstStr + otherStr;
        });
        return str;
      },
    },
    legend: {
      right: 0,
      top: 0,
      bottom: 0,
      icon: 'rect',
      textStyle: {
        color: 'rgba(255,255,255,0.85)',
      },
      itemWidth: 12,
      itemHeight: 8,
      itemGap: 24,
      padding: [0, 8, 0, 0],
    },
    xAxis: {
      type: 'category',
      data: xData,
      axisTick: {
        show: false,
      },
      axisLabel: {
        margin: 8,
        color: 'rgba(255,255,255,0.85)',
        lineHeight: 20,
        fontSize: 10,
        formatter: function (e: number) {
          return dayjs(e, 'x').format('MM-DD');
        },
        hideOverlap: true
      },
    },
    yAxis: {
      type: 'value',
      name: 'kWh',
      nameGap: 8,
      splitLine: {
        lineStyle: {
          color: 'rgba(255,255,255,0.3)',
        },
      },
      nameTextStyle: {
        color: 'rgba(255,255,255,0.85)',
        lineHeight: 20,
      },
      axisLine: {},
      axisLabel: {
        margin: 8,
        color: 'rgba(255,255,255,0.85)',
        lineHeight: 20,
      },
    },
    series: [
      {
        type: 'bar',
        name: '充电量',
        stack: 'total',
        barWidth: 5,
        itemStyle: {
          color: '#16DD8E',
        },
        data: chargeData,
      },
      {
        type: 'bar',
        name: '放电量',
        stack: 'total',
        barWidth: 5,
        itemStyle: {
          color: '#2D8DFF',
        },
        data: disChargeData,
      },
    ],
  };
};
